import { ApiError, isApiError } from '../instance/error';

const CREDIT_SHORTAGE_ERROR_CODE = 'CREDIT_001';

export const isCreditShortageCode = (code: string | undefined): boolean =>
  code === CREDIT_SHORTAGE_ERROR_CODE;

export const isCreditShortageError = (error: unknown): error is ApiError =>
  isApiError(error) && error.code === CREDIT_SHORTAGE_ERROR_CODE;
